import styled from 'styled-components';
import {dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const body = styled.div`
    ${dFlexColumn}
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    gap: var(--space-xl);
    padding: var(--space-lg);
    scrollbar-width: thin;
    scrollbar-color: var(--color-border-subtle) transparent;
    &::-webkit-scrollbar {
        width: var(--space-xs);
    }
    &::-webkit-scrollbar-thumb {
        background: var(--color-border-subtle);
        border-radius: var(--radius-full);
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
`;

export const separator = styled.hr`
    height: 0;
    margin: 0;
    border: none;
    border-top: 1px solid var(--color-border-subtle);
`;
